import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { history } from "../../helper/history";
import { userService } from "../../services/user";
import { brandService } from "../../services/brand";

export const brandActions = {
    // getCurrentUser,
    updatePermission,
    getBrandsList,
    storeBrand,
    storeBrandProductAtts,
    storeBrandOrderAtts,
    storeBrandExportAtts,
    deleteBrand,
    getBrandDataWithKey,
    getBrandProductData,
    getAllBrands,
    storeCustomerBrand,
    getAllCustomerBrands,
    deleteCustomerBrand,
    storeBrandDataDefinition,
    getBrandDataDefinitions,
    editBrandDataDefinition,
    storeCustomerTagLayout,
    getBrandTagLayoutsPagination,
    deleteTagLayout,
    getTagLayout,
    editTagLayout,
    storeTransformationRules,
    storeBrandLookupTable,
    getBrandLookupDefinitionsPagination,
    getBrandsListDropDown,
    getBrandLookupDefinitionsData,
    getTransformationRulesListing,
    markActiveVersion,
    sortTransformationRules,
    updateBrand,
    deleteTransformationRule,
    deleteBrandDataDefinition,
    getBrandSettings,
    updateBrandSettings,
    changeSftpPassword,
    deleteLookupDefinition,
    cloneDataDefinition,
    deleteBrandProduct,
    getProductsWithIds,
};

function editTagLayout(data, id) {
    return dispatch => {
        return brandService.updateTagLayout(data, id).then(
            response => {
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getTagLayout(id) {
    return dispatch => {
        return brandService.getTagLayout(id).then(
            response => {
                dispatch({
                    type: adminConstants.GET_TAG_LAYOUT_SUCCESS,
                    payload: response
                });
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getBrandTagLayoutsPagination(id, filter, page, sort, pageSize, for_order) {
    return dispatch => {
        //dispatch(request());
        return brandService
            .getBrandTagLayoutsPagination(id, filter, page, sort, pageSize, for_order)
            .then(
                response => {
                    dispatch({
                        type: adminConstants.PAGINATION_TAG_LAYOUTS_SUCCESS,
                        payload: response
                    });
                },
                error => {
                    dispatch({
                        type: adminConstants.PAGINATION_TAG_LAYOUTS_FAILURE,
                        payload: error
                    });
                    dispatch(alertActions.error(error));
                }
            );
    };
}

function storeCustomerTagLayout(data) {
    return dispatch => {
        return brandService.saveTagLayout(data).then(
            response => {
                // dispatch({
                //     type: adminConstants.STORE_CUSTMER_ADDRESS,
                //     payload: response
                // });
                dispatch(alertActions.success(response.message));
                return data;
            },
            error => {
                //dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function updatePermission(userId) {
    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function () {
                    history.go(0);
                }, 500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_FAILURE,
            payload: error
        };
    }
}

function getBrandsListDropDown(page, filter, sort, pageSize) {
    return dispatch => {
        return brandService
            .getBrandsListDropdown(page, filter, sort, pageSize)
            .then(brandsData => {
                dispatch({
                    type: adminConstants.GET_BRANDS_DROPDOWN_LIST_SUCCESS,
                    payload: brandsData
                });
                return brandsData;
            });
    };
}

function getBrandsList(page, filter, sort, pageSize) {
    return dispatch => {
        dispatch(request());
        return brandService.getBrandsList(page, filter, sort, pageSize).then(
            brandsData => {
                dispatch(success(brandsData));
                return brandsData;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
    function request() {
        return { type: adminConstants.GET_BRANDS_LIST_REQUEST };
    }
    function success(brandsData) {
        return {
            type: adminConstants.GET_BRANDS_LIST_SUCCESS,
            payload: brandsData
        };
    }
    function failure(error) {
        return { type: adminConstants.GET_BRANDS_LIST_FAILURE, payload: error };
    }
}


function storeBrand(brandData) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrand(brandData).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                console.log("error 12355646", error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.STORE_BRAND_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.STORE_BRAND_FAILURE, payload: error };
    }
}

function storeBrandProductAtts(brandData, id) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrandProductAtts(brandData, id).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                // console.log('error 123', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_PRODUCT_ATTS_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.STORE_BRAND_PRODUCT_ATTS_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_BRAND_PRODUCT_ATTS_FAILURE,
            payload: error
        };
    }
}

function storeBrandOrderAtts(brandData, id) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrandOrderAtts(brandData, id).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                // console.log('error 123', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_ORDER_ATTS_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.STORE_BRAND_ORDER_ATTS_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_BRAND_ORDER_ATTS_FAILURE,
            payload: error
        };
    }
}

function storeBrandExportAtts(data, id) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrandExportAtts(data, id).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return data;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                // console.log('error 123', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_EXPORT_ATTS_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.STORE_BRAND_EXPORT_ATTS_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_BRAND_EXPORT_ATTS_FAILURE,
            payload: error
        };
    }
}

function storeBrandDataDefinition(brandData, id) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrandDataDefinition(brandData, id).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                // console.log('error 123', error);
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_DATA_DEFINITION_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.STORE_BRAND_DATA_DEFINITION_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_BRAND_DATA_DEFINITION_FAILURE,
            payload: error
        };
    }
}

function deleteBrand(brand_id) {
    return dispatch => {
        dispatch(request());
        return brandService.deleteBrand(brand_id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.DELETE_LIST_ITEM_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.DELETE_LIST_ITEM_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.DELETE_LIST_ITEM_FAILURE,
            payload: error
        };
    }
}

function deleteTagLayout(list_id) {
    return dispatch => {
        return brandService.deleteTagLayout(list_id).then(
            response => {
                dispatch(alertActions.success(response.message));
            },
            error => {
                //dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };
}

// function editList(listData, list_id) {
//     return dispatch => {
//         dispatch(request());
//         return listService.editList(listData, list_id).then(
//             response => {
//                 dispatch(success(response));
//                 dispatch(alertActions.success(response.message));
//                 console.log("edit");
//                 return listData;
//                 // setTimeout(function(){
//                 //     history.go(0);
//                 // }, 1500);
//             },
//             error => {
//                 dispatch(failure(error));
//                 dispatch(alertActions.error(error));
//             }
//         );
//     };

//     function request() {
//         return { type: adminConstants.EDIT_LIST_ITEM_REQUEST };
//     }
//     function success(response) {
//         return {
//             type: adminConstants.EDIT_LIST_ITEM_SUCCESS,
//             payload: response
//         };
//     }
//     function failure(error) {
//         return { type: adminConstants.EDIT_LIST_ITEM_FAILURE, payload: error };
//     }
// }

function getAllCustomerBrands(custId) {
    return dispatch => {
        dispatch(request());
        return brandService.getAllCustomerBrands(custId).then(
            list => {
                dispatch(success(list));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_CUSTOMER_BRANDS_REQUEST };
    }
    function success(list) {
        return {
            type: adminConstants.GET_CUSTOMER_BRANDS_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_CUSTOMER_BRANDS_FAILURE,
            payload: error
        };
    }
}

function getBrandDataWithKey(brandId) {
    return dispatch => {
        dispatch(request());
        return brandService.getBrandDataWithKey(brandId).then(
            list => {
                dispatch(success(list));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_DATA_BYKEY_REQUEST };
    }
    function success(list) {
        return {
            type: adminConstants.GET_BRAND_DATA_BYKEY_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_DATA_BYKEY_FAILURE,
            payload: error
        };
    }
}

function getBrandProductData(brandId, page, filter, sort, pageSize) {
    return dispatch => {
        dispatch(request());
        return brandService
            .getBrandProductData(brandId, page, filter, sort, pageSize)
            .then(
                data => {
                    dispatch(success(data));
                    return data;
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_PRODUCT_DATA_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.GET_BRAND_PRODUCT_DATA_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_PRODUCT_DATA_FAILURE,
            payload: error
        };
    }
}

function getAllBrands() {
    return dispatch => {
        dispatch(request());
        return brandService.getAllBrands().then(
            list => {
                dispatch(success(list));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_DATA_FOR_CUSTOMER_REQUEST };
    }
    function success(list) {
        return {
            type: adminConstants.GET_BRAND_DATA_FOR_CUSTOMER_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_DATA_FOR_CUSTOMER_FAILURE,
            payload: error
        };
    }
}

function storeCustomerBrand(brand_id, customer_id, data) {
    return dispatch => {
        return brandService.storeCustomerBrand(brand_id, customer_id, data).then(
            response => {
                dispatch(success(response));
                // dispatch(
                //     brandActions.getAllBrands()
                // );
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
    // function request() {
    //     return { type: adminConstants.STORE_CUSTOMER_BRAND_REQUEST };
    // }
    function success(response) {
        return {
            type: adminConstants.STORE_CUSTOMER_BRAND_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_CUSTOMER_BRAND_FAILURE,
            payload: error
        };
    }
}

function deleteCustomerBrand(brand_id, customer_id) {
    return dispatch => {
        brandService.deleteCustomerBrand(brand_id, customer_id).then(
            response => {
                // dispatch({
                //     type: adminConstants.DELETE_CUSTOMER_BRAND_SUCCESS,
                //     payload: response
                // });
                dispatch(
                    brandActions.getAllCustomerBrands(customer_id)
                )
                dispatch(alertActions.success(response.message));
            },
            error => { }
        );
    };
}

function getBrandDataDefinitions(brandId, page, filter, sort, pageSize) {
    return dispatch => {
        dispatch(request());
        return brandService
            .getBrandDataDefinitions(brandId, page, filter, sort, pageSize)
            .then(
                list => {
                    dispatch(success(list));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_DATA_DEFINITIONS_REQUEST };
    }
    function success(list) {
        return {
            type: adminConstants.GET_BRAND_DATA_DEFINITIONS_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_DATA_DEFINITIONS_FAILURE,
            payload: error
        };
    }
}

function editBrandDataDefinition(brandId, type) {
    return dispatch => {
        dispatch(request());
        return brandService.editBrandDataDefinition(brandId, type).then(
            data => {
                dispatch(success(data));
                return data;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);

            }
        );
    };

    function request() {
        return { type: adminConstants.EDIT_BRAND_DATA_DEFINITION_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.EDIT_BRAND_DATA_DEFINITION_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.EDIT_BRAND_DATA_DEFINITION_FAILURE,
            payload: error
        };
    }
}

function storeTransformationRules(data, definitionId) {
    return dispatch => {
        dispatch(request());
        return brandService.storeTransformationRules(data, definitionId).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
                return data;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_TRANSFORMATION_RULES_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.STORE_TRANSFORMATION_RULES_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_TRANSFORMATION_RULES_FAILURE,
            payload: error
        };
    }
}

function storeBrandLookupTable(data, brandId) {
    return dispatch => {
        dispatch(request());
        return brandService.storeBrandLookupTable(data, brandId).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
                return data;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_BRAND_LOOKUP_TABLE_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.STORE_BRAND_LOOKUP_TABLE_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.STORE_BRAND_LOOKUP_TABLE_FAILURE,
            payload: error
        };
    }
}

function getBrandLookupDefinitionsPagination(
    brandId,
    page,
    filter,
    sort,
    pageSize
) {
    return dispatch => {
        dispatch(request());
        return brandService
            .getBrandLookupDefinitionsPagination(
                brandId,
                page,
                filter,
                sort,
                pageSize
            )
            .then(
                list => {
                    dispatch(success(list));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() {
        return {
            type: adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_REQUEST
        };
    }
    function success(list) {
        return {
            type:
                adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type:
                adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_PAGINATION_FAILURE,
            payload: error
        };
    }
}
function getBrandLookupDefinitionsData(brandId) {
    return dispatch => {
        dispatch(request());
        return brandService.getBrandLookupDefinitionsData(brandId).then(
            list => {
                dispatch(success(list));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return {
            type: adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_REQUEST
        };
    }
    function success(list) {
        return {
            type: adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_LOOKUP_DEFINITIONS_DATA_FAILURE,
            payload: error
        };
    }
}

function getTransformationRulesListing(id, type) {
    return dispatch => {
        dispatch(request());
        return brandService.getTransformationRulesListing(id, type).then(
            data => {
                dispatch(success(data));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return {
            type: adminConstants.GET_TRANSFORMATION_RULES_LISTING_REQUEST
        };
    }
    function success(data) {
        return {
            type: adminConstants.GET_TRANSFORMATION_RULES_LISTING_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_TRANSFORMATION_RULES_LISTING_FAILURE,
            payload: error
        };
    }
}

function markActiveVersion(definition_id) {
    return dispatch => {
        dispatch(request());
        return brandService.markActiveVersion(definition_id).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.MARK_ACTIVE_VERSION_DEFINITION_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.MARK_ACTIVE_VERSION_DEFINITION_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.MARK_ACTIVE_VERSION_DEFINITION_FAILURE,
            payload: error
        };
    }
}
function sortTransformationRules(data) {
    return dispatch => {
        dispatch(request());
        return brandService.sortTransformationRules(data).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.SORT_TRANSFORMATION_RULES_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.SORT_TRANSFORMATION_RULES_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.SORT_TRANSFORMATION_RULES_FAILURE,
            payload: error
        };
    }
}

function updateBrand(id, brandData) {
    return dispatch => {
        dispatch(request());
        return brandService.updateBrand(id, brandData).then(
            response => {
                // console.log('response 123', response);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.UPDATE_BRAND_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.UPDATE_BRAND_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.UPDATE_BRAND_FAILURE, payload: error };
    }
}

function deleteTransformationRule(rule_id) {
    return dispatch => {
        dispatch(request());
        return brandService.deleteTransformationRule(rule_id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.DELETE_TRANSFORMATION_RULE_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.DELETE_TRANSFORMATION_RULE_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.DELETE_TRANSFORMATION_RULE_FAILURE,
            payload: error
        };
    }
}


function deleteBrandDataDefinition(definition_id) {
    return dispatch => {
        dispatch(request());
        return brandService.deleteBrandDataDefinition(definition_id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.DELETE_BRAND_DATA_DEFINITION_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.DELETE_BRAND_DATA_DEFINITION_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.DELETE_BRAND_DATA_DEFINITION_FAILURE,
            payload: error
        };
    }
}


function getBrandSettings(model, model_id) {
    return dispatch => {
        dispatch(request());
        return brandService.getBrandSettings(model, model_id).then(
            data => {
                dispatch(success(data));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_SETTINGS_REQUEST };
    }
    function success(data) {
        return { type: adminConstants.GET_BRAND_SETTINGS_SUCCESS, payload: data };
    }
    function failure(error) {
        return { type: adminConstants.GET_BRAND_SETTINGS_FAILURE, payload: error };
    }
}

function updateBrandSettings(brandId, settingsData) {
    return dispatch => {
        dispatch(request());
        return brandService.updateBrandSettings(brandId, settingsData).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
                return data;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.UPDATE_BRAND_SETTINGS_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.UPDATE_BRAND_SETTINGS_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.UPDATE_BRAND_SETTINGS_FAILURE,
            payload: error
        };
    }
}


function changeSftpPassword(data) {
    return dispatch => {
        dispatch(request());
        return brandService.changeSftpPassword(data).then(
            data => {
                dispatch(success(data));
                dispatch(alertActions.success(data.message));
                return data;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.UPDATE_BRAND_SETTINGS_REQUEST };
    }
    function success(data) {
        return {
            type: adminConstants.UPDATE_BRAND_SETTINGS_SUCCESS,
            payload: data
        };
    }
    function failure(error) {
        return {
            type: adminConstants.UPDATE_BRAND_SETTINGS_FAILURE,
            payload: error
        };
    }
}


function deleteLookupDefinition(id) {
    return dispatch => {
        return brandService.deleteLookupDefinition(id).then(
            response => {
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function cloneDataDefinition(id) {
    return dispatch => {
        return brandService.cloneDataDefinition(id).then(
            response => {
                dispatch(alertActions.success(response.message));
                return response;
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function deleteBrandProduct (id) {
    return dispatch => {
        return brandService.deleteBrandProduct(id).then(
            response => {
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function getProductsWithIds(brandId, page, filter, sort, pageSize) {
    return dispatch => {
        dispatch(request());
        return brandService
            .getProductsWithIds(brandId, page, filter, sort, pageSize)
            .then(
                list => {
                    dispatch(success(list));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() {
        return { type: adminConstants.GET_BRAND_PRODUCT_DATA_REQUEST };
    }
    function success(list) {
        return {
            type: adminConstants.GET_BRAND_PRODUCT_DATA_SUCCESS,
            payload: list
        };
    }
    function failure(error) {
        return {
            type: adminConstants.GET_BRAND_PRODUCT_DATA_FAILURE,
            payload: error
        };
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/brand-actions.jsx